import React, { useContext } from 'react';
import { Row, Col, CardBody, Card, Container  } from "reactstrap";
import { useTranslation } from 'react-i18next';
import { faFileAlt, faUpload, faCalendarAlt, faUser, faAddressBook, faUsers, faShieldHalved } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom';
import DashboardCards from 'components/common/DashboardCards';
import AssistantWelcomeCard from 'components/assistant/AssistantWelcomeCard';
import { UserSettingsContext } from 'contexts/UserSettingsContext';
import Skeleton from 'react-loading-skeleton';

const welcomeMsg = 'speicherfuchs.welcomeMessage';

const cards = [
    {
        title: 'settings.dashboardCards.users.title',
        text: 'settings.dashboardCards.users.text',
        icon: faUsers,
        link: '/admin/users'
    },
    {
        title: 'settings.dashboardCards.rightsRoles.title',
        text: 'settings.dashboardCards.rightsRoles.text',
        icon: faShieldHalved,
        link: '/admin/roles'
    }
  ];

function SettingsDashboard() {
    const { t } = useTranslation();

    const { userId } = useContext(UserSettingsContext);
    if(!userId){
        return <Card><CardBody><Skeleton height={40} count={5} /></CardBody></Card>
    }

    return (
        <Card className="card-tasks" style={{ height: "auto", marginLeft: "10px", borderRadius: '0.875rem', overflow: 'hidden' }}>
            <CardBody>
                <h3 className="title">{t('settings.title')}</h3>
                <Row className="align-items-center">
                    <Col lg="12" xl="6" className="order-2 order-xl-1">
                        <Container className="my-4">
                            <DashboardCards cards={cards.filter(card => (card.role || userId.tenant_role) === userId.tenant_role)} />
                        </Container>        
                    </Col>
                </Row>  
                
            </CardBody>
        </Card>
    )
}

export default SettingsDashboard;